<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\myCourseManual-1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào [Khóa học của tôi] trên thanh tiêu đề, thì tất cả các khóa học mà bạn là học viên sẽ được hiển thị.</p>
                    <p>② Các nút bên cạnh nút [Tất cả] là phân loại của các khóa học (Các nút này sẽ khác nhau tùy theo từng tổ chức sử dụng).</p>
                    <p>③ Nhất vào nút cài đặt để cài đặt việc hiển thị của các nút phân loại ở mục ②.</p>
                    <p>※ Các khóa học được hiển thị trong bảng số liệu không bao gồm các khóa học đã kết thúc (tức những khóa học bạn đã học xong và đã gửi [Yêu cầu kết thúc]).</p>
                    <p>&nbsp; Lúc này, nút [Gồm cả khóa học đã hoàn thành] ở trạng thái chưa được kích hoạt.</p>
                </div>
                <div><img src="/static\images\vi\newManual\myCourseManual-2.png" alt="" /></div>
                <div>
                    <p>Cài đặt việc hiển thị của các loại khóa học bằng cách kích hoạt các nút, hoặc nhấn [Bỏ chọn tất cả] rồi nhấn nút [Lưu].</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/en/myCourse_manual.vue